import { createStore, applyMiddleware } from "redux";
import { createReducer } from "reducers/createReducer.js";
import { routerMiddleware } from "connected-react-router";
import thunkMiddleware from "redux-thunk";
import LogRocket from "logrocket";

const initializeStore = (history) => {
	const store = createStore(
		createReducer({ history }),
		process.env.NODE_ENV !== "production" && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
		applyMiddleware(
			thunkMiddleware,
			routerMiddleware(history),
			LogRocket.reduxMiddleware({
				stateSanitizer(state) {
					return {
						...state,
						base: {
							analysis: undefined,
							content: undefined,
							dataStoreMap: undefined,
							dataStoreEntities: undefined,
							dataStoreGraph: undefined,
							dataStoreContent: undefined,
							dataStoreFilters: undefined,
						},
						leftCompare: {
							analysis: undefined,
							content: undefined,
							dataStoreMap: undefined,
							dataStoreMapDetail: undefined,
							dataStoreEntities: undefined,
							dataStoreGraph: undefined,
							dataStoreGraphDetail: undefined,
							dataStoreContent: undefined,
						},
						rightCompare: {
							analysis: undefined,
							content: undefined,
							dataStoreMap: undefined,
							dataStoreMapDetail: undefined,
							dataStoreEntities: undefined,
							dataStoreGraph: undefined,
							dataStoreGraphDetail: undefined,
							dataStoreContent: undefined,
						},
					};
				},
			})
		)
	);

	store.asyncReducers = {};
	store.injectReducer = (key, reducer) => {
		store.asyncReducers[key] = reducer;
		store.replaceReducer(createReducer({ asyncReducers: store.asyncReducers, history }));
		return store;
	};

	return store;
};

export default initializeStore;
